if (!customElements.get("ingredients-navigation")) {
  customElements.define(
    "ingredients-navigation",
    class IngredientsNavigation extends HTMLElement {
      constructor() {
        super();

        const allLetterButtons = this.querySelectorAll(".js-letter");
        const allIngredientCards = this.querySelectorAll(".js-ingredient-card");
        function handleLetterClick(event) {
          // we define the active letter we click

          let activeLetter = event.target.dataset.firstLetter;
          // hiding/showing the ingredients cards, based on which letter is active
          if (activeLetter === "all") {
            allIngredientCards.forEach(function (content) {
              content.classList.remove("hidden");
            });
          } else {
            allIngredientCards.forEach(function (content) {
              if (content.dataset.firstLetter === activeLetter) {
                content.classList.remove("hidden");
              } else {
                content.classList.add("hidden");
              }
            });
          }

          // setting the active letter-button
          allLetterButtons.forEach((btn) => {
            if (event.target !== btn) {
              btn.classList.remove("js-letter--active");
            }
          });
          event.target.classList.add("js-letter--active");
        }
        allLetterButtons.forEach((button, index) => {
          button.addEventListener("click", handleLetterClick);
        });
      }
    }
  );
}
